const lbaHotelReview = angular.module('app.lbaHotelReview', ['ngTasty']);

lbaHotelReview.controller('lbaHotelReviewCtrl', require('./lbaHotelReviewCtrl'));
lbaHotelReview.directive('lbaHotelReview', require('./lbaHotelReviewDir'));
lbaHotelReview.service('hotelsService', require('../../services/hotelsService'));


export default lbaHotelReview;



// WEBPACK FOOTER //
// ./src/components/lbaHotelReview/index.js